export default __webpack_public_path__ + "static/media/wave7.a86a50ae.png";